module.exports = __webpack_public_path__ + "static/media/CuteIcons.15e38771.ttf";